// extracted by mini-css-extract-plugin
export default {"titleMobile":"UlOeM2","dateLocationMobile":"mUCh9I"};